import type { TFunction } from 'i18next'

/**
 * API 에러 응답에서 번역된 에러 메시지를 추출합니다.
 * 에러 코드 → i18n 번역 → 백엔드 영어 메시지 → 기본 메시지 순으로 fallback
 */
export function getApiErrorMessage(error: any, t: TFunction): string {
  const errorInfo = error?.response?.data?.error
  if (errorInfo?.code) {
    const key = `apiError.${errorInfo.code}`
    const translated = t(key, { ns: 'common', defaultValue: '' })
    if (translated) return translated
  }
  return errorInfo?.message
    || error?.response?.data?.message
    || error?.message
    || t('error.unknown', { ns: 'common' })
}

/**
 * API 에러 응답에서 에러 코드를 추출합니다.
 */
export function getApiErrorCode(error: any): string | undefined {
  return error?.response?.data?.error?.code
}
